<template>
  <div class="h100 bg-color">
     <header>
      <div class="head-left">
        <a class="logo" v-if=" logoUrl!== ''">
          <img class="logo-width" :src="logoUrl" alt="logo"/>
        </a>
        <a class="logo-lenovo" v-else-if="islogoLenovo">
          <img src="../images/LenovoLogo-Chinese_POS-Blue-H.png" alt="logo"/></a>
        <a class="logo" v-else><img src="../images/songshuAI_logo.png" alt="logo"/></a>
        <div class="test-title">
          <h4>
            <span>{{subject}}</span>
            <i>.</i>
            <span>{{version}}</span>
            <i>.</i>
            <span>{{grade}}</span>
            <i>.</i>
            <span>{{test}}</span></h4>
          <p>本轮预计时间：{{allTime}}</p>
        </div>
      </div>
      <div class="user-wrap">
        <span v-if="userName"><i class="icon icon-user_name"></i>{{userName}}</span>
        <!-- <span id="logOut" @click.stop="logOut" v-if="sourceType!=1">
          <i class="icon icon-out"></i>退出</span> -->
      </div>
    </header>
    <div class="question-wrap-wrap">
      <section class="question-wrap">
      <div class="answer-wrap">
        <myProgress type="line" :proportion="answerProgress"></myProgress>
        <choose
          v-if="hardReset"
          @getFatherQuestion="getQuestion"
          :responseData="answerData"
          ref="questionChild" :element="clickElement"
        />
      </div>
      <div class="answer-time-wrap">
        <div class="answer-time">
          <div class="progress-circle">
            <svg viewBox="0 0 100 100">
              <defs>
                <linearGradient v-if="overtime" id="linear" x1="0%" y1="0%" x2="100%" y2="0%">
                  <stop offset="0%"   stop-color='#FF4438'/>
                  <stop offset="100%" stop-color='#FFAC1D'/>
                </linearGradient>
                <linearGradient v-else id="linear" x1="0%" y1="0%" x2="100%" y2="0%">
                  <stop offset="0%"   stop-color='#4E74FF'/>
                  <stop offset="100%" stop-color='#00B1FF'/>
                </linearGradient>
              </defs>
              <path  v-if="is_progress"  class="el-progress-circle__path"
                     d="M 50 50 m 0 -48 a 48 48 0 1 1 0 96 a 48 48 0 1 1 0 -96"
                     stroke-linecap="round" stroke="url(#linear)"
                     stroke-width="3" fill="none" :style="circlePathStyle">
              </path>
            </svg>
          </div>
          <p class="progress-text"><span>用时</span><br />{{useTimeData.to_use_time}}</p>
        </div>
        <p class="user-time">
          本题建议用时<br/>
          {{suggestTime}}
        </p>
        <p class="time-code">试题ID：{{q_id}}</p>
      </div>
    </section>
    </div>
    <footer class="answer-foot">
      <div class="w900">
        <el-button round class="answer-jump" v-debounce="submitQuestionChildJump">我不会，跳过</el-button>
        <el-button type="primary"
        round class="answer-submit"
        v-debounce="submitQuestionChild">提  交</el-button>
      </div>
    </footer>
  </div>
</template>

<script>
/* eslint-disable */
import myProgress from './components/myProgress.vue'
import choose from './question'
import { getSign } from '@/pages/dl-web/utils/verify.js'
import api from '@/pages/dl-web/api/api.js'
import { getPercentTime, formatSeconds,formatTimeBySubject } from '@/pages/dl-web/utils/index.js'
// import {getLogo} from '@/utils/auth'

var interval = null   // 做题倒计时
export default {
  name: 'answerLayout',
  components: {
    'myProgress': myProgress,
    'choose': choose,
  },
  data () {
    return {
      tsid: '',
      course_type: this.$route.query.courseType, // 是否是v5
      q_id: '',
      subject: '', // 物理
      version: '', // 沪粤版
      grade: '', // 九年级
      test: '', // 第十二章内燃机
      overtime: false, // 是否超时
      userName: '',
      suggestTime: 0, // 本题建议用时
      suggestTimeFm: 0,
      allTime: 0, // 建议测试总用时
      is_progress: false, // 是否显示时间进度
      answerProgress: {
        all_question_num: 0, // 总题数
        question_num: 0 // 当前题数
      },
      useTimeData: {
        percentAge: 0, // 进度条进度
        toUseTime: 0, // 用户答题时间
        to_use_time: '00:00',  // 显示答题时间
        strokeWidth: 3, // 进度条宽度
        width: 176
      },
      clickElement: undefined,
      answerData: '', // 取题内容
      hardReset: false, // 拿到数据后重新渲染子组件
      sourceType:0, // 判断是不是钉钉环境 1钉钉
      logoUrl: '', // logo替换地址
    }
  },
  directives: {
    debounce: {
      inserted: function (el, binding) {
        let timer
        el.addEventListener('click', () => {
          if (timer) {
            clearTimeout(timer)
          }
          timer = setTimeout(() => {
            binding.value()
          }, 300)
        })
      }
    }
  },
  created () {
    if (this.$route.query.schoolId) {
      localStorage.setItem('school_id',this.$route.query.schoolId);
    }
    //如果是从uc跳过来的,则获取token
    if (this.$route.query.token) {
      localStorage.setItem('token',this.$route.query.token);
    }
    if (this.$route.query.userName) {
      this.userName = this.$route.query.userName
    }else{
      this.userName = localStorage.getItem('real_name') || ''
    }
     if (this.$route.query.sourceType) {
      this.sourceType = this.$route.query.sourceType
    }
    // 防止页面后退
    history.pushState(null, null, document.URL)
    window.addEventListener('popstate', function () {
      history.pushState(null, null, document.URL)
    })
  },
  async mounted () {
    this.tsid = this.$route.query.id
    this.getQuestion()
    const accountId = localStorage.getItem('school_id');
    // getLogo 接口不再调用
    // await getLogo(accountId)
    const logo = JSON.parse(sessionStorage.getItem(`${accountId}-ChangeLogoUrl`)) || {};
    this.logoUrl = logo.logoUrl;
  },
  computed: {
    //判断是否为特殊校区(隐藏、替换logo)
    islogoLenovo(){
      let id = this.$route.query.schoolId||'';
      return id ==='20023' || id === '20022' || id === '20043' || id === '2217';
    },
    relativeStrokeWidth () {
      return (this.useTimeData.strokeWidth / this.useTimeData.width * 100).toFixed(1)
    },
    perimeter () {
      const radius = 50 - parseFloat(this.relativeStrokeWidth) / 2
      return 2 * Math.PI * radius
    },
    circlePathStyle () {
      const perimeter = this.perimeter
      return {
        strokeDasharray: `${perimeter}px,${perimeter}px`,
        strokeDashoffset: (1 - this.useTimeData.percentAge / this.suggestTimeFm) * perimeter + 'px',
        transition: 'stroke-dashoffset 0.6s ease 0s, stroke 0.6s ease'
      }
    }
  },
  methods: {
    usetime: function () {
      var that = this
      interval = window.setInterval(function () {
        that.useTimeData.percentAge++
        that.useTimeData.toUseTime++
        that.useTimeData.to_use_time = getPercentTime(that.useTimeData.toUseTime)
        if (that.useTimeData.percentAge >= that.suggestTimeFm) {
          that.overtime = true
          that.useTimeData.percentAge = that.suggestTimeFm
        }
      }, 1000)
    },
    getQuestion: async function () {
      this.hardReset= false
      let that = this
      let params = {
        tsid: that.tsid,
        time_stamp: (new Date()).getTime()
      }
      params.sign = getSign(params)
      let res
      if(this.course_type=='V5'){
        res = await api.getQuestioninfoV5(params)
      }else{
        res = await api.getQuestioninfo(params)
      }
      if (res) {
        if(res.code == 0){
          this.is_progress = true
          this.hardReset= true
          this.q_id = res.data.question_info.question_id || ''
          this.useTimeData.toUseTime = 0
          this.useTimeData.percentAge = 0
          this.useTimeData.to_use_time = '00:00'
          this.overtime = false
          window.clearInterval(interval)
          this.usetime() // 重新启动计时器
          this.answerData = res.data
          console.log(res.data)
          this.subject = res.data.info.subject
          this.version = res.data.info.version
          this.grade = res.data.info.grade
          this.test = res.data.info.test
          this.answerProgress.all_question_num = res.data.all_question_num || ''
          this.answerProgress.question_num = res.data.question_num || ''
          this.suggestTime = formatSeconds(res.data.advise_time) || ''
          this.suggestTimeFm = res.data.advise_time || ''
          this.allTime = formatTimeBySubject(this.subject,this.answerProgress.all_question_num) || 0
          let subject = res.data.info.subject
          let stage = res.data.info.stage || '40'
          if(subject == '物理'){
            sessionStorage.setItem('dl-subjectId', 4)
          }
          if(subject == '化学'){
            sessionStorage.setItem('dl-subjectId', 5)
          }
          if(subject == '数学'){
            sessionStorage.setItem('dl-subjectId', 2)
          }
          sessionStorage.setItem('dl-stage', stage)

        }else if (res.code === 1002) {
          this.goReport(that.tsid, '做题记录已存在，去报告页')
        }else if (res.code === 1004) {
          this.goReport(that.tsid, '测试已完成', true)
        }else{
          this.$toast(res.msg)
        }
      } else{
        // this.$toast('网络错误，请刷新重试')
      }
    },
    submitQuestionChild: function () {
      this.$refs.questionChild.subQuestion()
    },
    submitQuestionChildJump: function () {
      this.$refs.questionChild.subQuestionJump()
    },
    goReport: function (id, msg, isFinish) {
      let that = this
      let tsid = id
      let nextPath = '/dl-web/question/report'
      const schoolId = localStorage.getItem('school_id')
      this.$toast(msg)

      setTimeout(function () {
        that.$router.push({
          path: nextPath,
          query: {
            id: tsid,
            schoolId:schoolId,
          }
        })
      },1000)
    },
    clearUserInfo: function () {
      localStorage.clear()
      sessionStorage.removeItem('channel')
    },
    closeLoading: function(){
      this.loading.close()
    },
    logOut: async function (){
      let that = this
      let params = {
        time_stamp: (new Date()).getTime()
      }
      params.sign = getSign(params)
      let res =  await api.logOut(params)
      if(res){
        if(res.code == 0){
          this.$toast('成功退出')
          this.clearUserInfo() // 清空用户信息
          setTimeout(function () {
            that.$router.push('/dl-web/login')
          },1500)
        }else{
          this.$toast(res.msg)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
body{
  .MJXc-display{
    display: inline-block;
  }
  p{
    margin-block-start: 0em;
    margin-block-end: 0em;
  }
    header{
    position: fixed;
    z-index: 999;
    top: 0;
    display: flex;
    box-sizing: border-box;
    width: 100%;
    height: 64px;
    justify-content: space-between;
    min-width: 780px;
    padding: 14px 40px;
    box-shadow: 0 2px 5px 0 rgba(0,0,0,0.05);
    background: #fff;
    font-size: 14px;
    .head-left{
      display: flex;
      .logo img{
        width: 200px;
      }
      .logo-lenovo{
        margin-top: 5px;
        width: 120px;
      }
      .test-title{
        position: relative;
        margin-left: 15px;
        padding-left: 15px;
        h4{
          line-height: 24px;
          font-family: PingFangSC-Medium;
          font-weight: 500;
          i{
            font-style: normal;
            font-size: 30px;
            line-height: 5px;
            vertical-align: top;
            margin: 3px;
          }
        }
        p{
          font-family: PingFangSC-Regular;
          font-size: 12px;
          color: rgba(153,153,153,0.85);
          line-height: 12px;
        }
      }
      .test-title:before{
        position: absolute;
        content: "";
        left: 0;
        top: 6px;
        width: 1px;
        height: 24px;
        background: #ccc;
      }
    }
    .user-wrap{
      display: flex;
      align-items: center;
      #logOut{
        cursor: pointer;
      }
      span{
        margin-left: 24px;
      }
      .icon{
        vertical-align: middle;
        margin-right: 8px;
        font-size: 20px;
      }
    }
  }
  .question-wrap-wrap{
    position: relative;
    min-height: 100%;
    background: rgba(249,249,249,.85);
  }
  section.question-wrap{
    position: relative;
    width: 1012px;
    max-width: 95%;
    padding-bottom: 100px;
    min-height: calc(100% - 210px);
    margin: 0 auto 24px auto;
    padding-top: 88px;
    .answer-wrap{
      max-width: 900px;
      width: 100%;
      margin: 0 auto;
      min-height: 576px;
      padding-bottom: 20px;
      background: rgba(255,255,255,0.67);
      box-shadow: 0 2px 5px 0 rgba(51,59,69,0.15);
      border-radius: 0px 0px 10px 10px;
    }
    .answer-time-wrap{
      position: absolute;
      top: 88px;
      right: -58px;
      width: 92px;
      text-align: center;
      .user-time,.time-code{
        padding-top: 15px;
        font-family: PingFangSC-Regular;
        font-size: 12px;
        color: rgba(153,153,153,0.85);
        line-height: 12px;
      }
      .time-code{
        text-align: left;
        word-break: normal;
      }
    }
    @media screen and (max-width:1200px) {
      .answer-time-wrap {
        display: none;
      }
    }
    .answer-time{
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 92px;
      height: 92px;
      background: url("../images/circle_time_bg.png") no-repeat;
      background-size: cover;
      border-radius: 50%;
      .progress-circle{
        width: 68px;
        margin-top: 4px;
        svg{
          /*stroke-dasharray: 303.792px, 303.792px; stroke-dashoffset: 100.517px;*/
          transition: stroke-dashoffset 0.6s ease 0s, stroke 0.6s ease 0s;
        }
      }
      .progress-text{
        position: absolute;
        z-index: 99;
        text-align: center;
        font-size: 12px;
        span{
          font-size: 12px;
          color: #999;
        }
      }
    }
  }
  footer.answer-foot{
    position: fixed;
    bottom: 0;
    width: 100%;
    padding: 16px 0;
    background: #FFF;
    box-shadow: 0 -2px 5px 0 rgba(0,0,0,0.05);
    .el-button+.el-button{
      margin-left: 20px;
    }
    .w900{
      width: 900px;
      margin: 0 auto;
      text-align: right;
      .el-button{
        width: 200px;
        border: none;
        font-size: 20px;
      }
      .answer-jump{
        height: 48px;
        background: #E8F3FF;
        border-radius: 24px;
        color: #45BCFF;
      }
      .answer-submit{
        background-image: linear-gradient(0deg, #4E74FF 3%, #00B1FF 97%);
        border-radius: 24px;
      }
    }
  }
  .logo-width {
    height: 32px;
    width: 160px !important;
  }
}
@media screen and (max-width: 1200px) {
  body footer.answer-foot .w900 {
    width: unset;
  }
}
</style>
